import { Component, Input, OnChanges, SimpleChanges, inject } from '@angular/core';
import { tap } from 'rxjs';

import { Meeting } from '@ninety/platform/models/meetings/meeting';
import { SpinnerService } from '@ninety/platform/state';
import { ClockTimerComponent } from '@ninety/ui/core';

import { MeetingService } from '../../_shared/services/meeting.service';

@Component({
  selector: 'ninety-meeting-duration',
  templateUrl: './meeting-duration.component.html',
  standalone: true,
  imports: [ClockTimerComponent],
})
export class MeetingDurationComponent implements OnChanges {
  private meetingService = inject(MeetingService);
  private spinnerService = inject(SpinnerService);

  @Input()
  meeting: Meeting;

  duration = 0;

  ngOnChanges(_changes: SimpleChanges): void {
    this._getElapsedMeetingDuration();
  }

  private _getElapsedMeetingDuration() {
    if (this.meeting.previousMeetingId || this.meeting.nextMeetingId) {
      this.spinnerService.start();
      this.meetingService
        .getMeetingDetail(this.meeting.previousMeetingId ?? this.meeting.nextMeetingId)
        .pipe(
          tap(previousMeeting => {
            this.duration = this.meeting.elapsedTime + previousMeeting.elapsedTime;
            this.spinnerService.stop();
          })
        )
        .subscribe();
    } else {
      this.duration = this.meeting.elapsedTime;
    }
  }
}
